import Headroom from 'headroom.js';

function hideOnScroll() {
  let header = document.querySelector('.js-header');
  if (header) {
    header = new Headroom(header, {
      tolerance: 5
    });
    header.init();
  }
}

const scrollToggle = () => {
  hideOnScroll();
};

export default scrollToggle;
